export class SelfCard {
    http;
    constructor(http) {
        this.http = http;
    }
    getShortCard(cityId, conceptId, guid) {
        return this.http.get(`/api/self_card/${cityId}/${conceptId}`, { guid }).json();
    }
    getExtendedCard(cityId, conceptId, sizeId, guid) {
        return this.http.get(`/api/self_card/${cityId}/${conceptId}/${sizeId}`, { guid }).json();
    }
}
